export default "__VITE_ASSET__CW$BMjwr__"